export interface BannerInfo {
  message: string;
  level: 'info' | 'warning' | 'error';
  redirectTo?: string;
  properties?: Record<string, string>;
}

// Offer the possibility to pass a function that returns a BannerInfo object
// This is useful when the checks to determine the banner message are expensive (e.g. validating config items)
// And we don't want to run them unless the banner is actually shown (e.g. when devtools are enabled)
export type Banner = BannerInfo | (() => BannerInfo | null);

export type Listener = (bannerInfo: Banner) => void;

export class DeveloperBannerManager {
  private static instance: DeveloperBannerManager;
  public setBanner: Listener = () => {};

  private constructor() {}

  public setListener(setBanner: Listener): void {
    this.setBanner = setBanner;
  }

  public static getInstance(): DeveloperBannerManager {
    if (!DeveloperBannerManager.instance) {
      DeveloperBannerManager.instance = new DeveloperBannerManager();
    }
    return DeveloperBannerManager.instance;
  }

  public static reset(): void {
    DeveloperBannerManager.instance.setBanner = () => {};
  }
}
